import { useMemo } from "react";
import { withClientContext } from "~/apollo/client";
import { useGetGroupsQuery } from "~/graphql/mainHooks";
import { CanopyRoleData } from ".";

type Args = {
  userIds?: string[];
};
export const useFetchCanopyRolesData = (args?: Args) => {
  const variables = useMemo(() => {
    if (args?.userIds) {
      return {
        userIds: args.userIds,
      };
    } else {
      return undefined;
    }
  }, [args?.userIds]);
  const useGetGroupsQueryResult = useGetGroupsQuery({
    context: withClientContext("staff"),
    variables,
    fetchPolicy: "network-only",
  });

  const rowData: CanopyRoleData[] = useMemo(() => {
    const canopyRoles =
      useGetGroupsQueryResult.data?.groups?.edges.map((edge) => ({
        id: edge.node.id,
        title: edge.node.title ?? "",
        memberCount: edge.node.memberCount ?? 0,
      })) || [];
    return canopyRoles;
  }, [useGetGroupsQueryResult.data]);

  return { rowData, useGetGroupsQueryResult, refetch: useGetGroupsQueryResult.refetch };
};
